import {
    CREATE_SEND_BOOTCAMP_SUBSCRIPTION_REQUEST,
    CREATE_SEND_BOOTCAMP_SUBSCRIPTION_SUCCESS,
    CREATE_SEND_BOOTCAMP_SUBSCRIPTION_FAILURE,

    FETCH_BOOTCAMP_SUBSCRIPTION_REQUEST,
    FETCH_BOOTCAMP_SUBSCRIPTION_SUCCESS,
    FETCH_BOOTCAMP_SUBSCRIPTION_FAILURE,

    UPDATE_BOOTCAMP_SUBSCRIPTION_REQUEST,
    UPDATE_BOOTCAMP_SUBSCRIPTION_SUCCESS,
    UPDATE_BOOTCAMP_SUBSCRIPTION_FAILURE,
    UPDATE_BOOTCAMP_SUBSCRIPTION_RESET

} from "./BootcampSubscriptionType"

import axios from "axios";

// Create

const createSendBootcampRequest = () => {
    return {
        type: CREATE_SEND_BOOTCAMP_SUBSCRIPTION_REQUEST,
    }
}

const createSendRequestBootcampSubscriptionSuccess = (success) => {
    return {
        type: CREATE_SEND_BOOTCAMP_SUBSCRIPTION_SUCCESS,
        payload: success
    }
}

const createSendRequestBootcampSubscriptionFailure = (error) => {
    return {
        type: CREATE_SEND_BOOTCAMP_SUBSCRIPTION_FAILURE,
        payload : error
    }
}

export const sendRequestBootcampSubscription = (data) => {
    return (dispatch) => {
        dispatch(createSendBootcampRequest());
        axios.post('/createRequestBootcampSubscription' , data)
        .then(response => {
            const res = response.data
            console.log(res.ok)
            dispatch(createSendRequestBootcampSubscriptionSuccess(res))
        })
        .catch(error => {
            const errorMsg = error.message
            dispatch(createSendRequestBootcampSubscriptionFailure(errorMsg))
        })  
    }
}

// Read

const fetchBootcampSubscriptionRequest = () => {
    return {
        type: FETCH_BOOTCAMP_SUBSCRIPTION_REQUEST,
    }
}

const fetchBootcampSubscriptionSuccess = success => {
    return {
        type: FETCH_BOOTCAMP_SUBSCRIPTION_SUCCESS,
        payload: success
    }
}

const fetchBootcampSubscriptionFailure = error => {
    return {
        type: FETCH_BOOTCAMP_SUBSCRIPTION_FAILURE,
        payload : error
    }
}

export const fetchBootcampSubscription = (data) => {
    
    return (dispatch) => {

        dispatch(fetchBootcampSubscriptionRequest());

        axios.post('/fetchRequestBootcampSubscription', data)
        .then(response => {
            const bootcampSubscription = response.data
            dispatch(fetchBootcampSubscriptionSuccess(bootcampSubscription))
         
        })
        .catch(error => {
            const errorMsg = error.message
            dispatch(fetchBootcampSubscriptionFailure(errorMsg))
        })
        
    }

}

export const updateBootcampSubscriptionReset = () => {
    return {
        type: UPDATE_BOOTCAMP_SUBSCRIPTION_RESET,
    }
}

const updateBootcampSubscriptionRequest = () => {
    return {
        type: UPDATE_BOOTCAMP_SUBSCRIPTION_REQUEST,
    }
}

const updateBootcampSubscriptionSuccess = success => {
    return {
        type: UPDATE_BOOTCAMP_SUBSCRIPTION_SUCCESS,
        payload: success
    }
}

const updateBootcampSubscriptionFailure = error => {
    return {
        type: UPDATE_BOOTCAMP_SUBSCRIPTION_FAILURE,
        payload : error
    }
}

export const updateBootcampSubscription = (data) => {

    return (dispatch) => {

        dispatch(updateBootcampSubscriptionRequest());
        
        axios.post('/updateBootcampSubscription', data)
        .then(response => {
            const bootcampSubscription = response.data
            dispatch(updateBootcampSubscriptionSuccess(bootcampSubscription))
        })
        .catch(error => {
            const errorMsg = error.message
            dispatch(updateBootcampSubscriptionFailure(errorMsg))
        })
        
    }

}

